<template>
    <b-modal id="editModal" ref="modal" title="Edit variety" v-model="show" @ok="handleSubmit" @hide="close" @shown="focusNameInput">

        <div class="form-group">
            <label>Variety Name</label>
            <div class="position-relative">
                <input type="text" ref="nameInput" name="name" v-validate="{required: true}" class="form-control" v-model="name">
                <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-link text-danger mr-auto" @click="handleDelete" v-if="!variety.deleted_at">
                Disable
            </button>
            <button class="btn btn-link text-danger mr-auto" @click="handleRestore" v-if="variety.deleted_at">
                Restore
            </button>
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" :disabled="okDisabled" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import deleteVarietyMutation from '@views/Varieties/EditModal/mutationDeleteVariety.graphql';
import restoreVarietyMutation from '@views/Varieties/EditModal/mutationRestoreVariety.graphql';
import updateVarietyMutation from '@views/Varieties/EditModal/mutationUpdateVariety.graphql';

export default {
  name: 'edit-modal',
  apollo: {},
  props: {
    variety: {
      type: Object,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      name: this.variety.name,
      show: true,
      loading: 0,
    };
  },
  computed: {
    okDisabled() {
      return this.name.length === 0;
    },
  },
  methods: {
    handleSubmit() {
      if (this.okDisabled) {
        return false;
      }
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        this.$apollo
          .mutate({
            mutation: updateVarietyMutation,
            variables: {
              input: {
                id: this.variety.id,
                name: this.name,
              },
            },
            optimisticResponse: {
              __typename: 'Mutation',
              updateVariety: {
                ...this.variety,
                name: this.name,
              },
            },
          })
          .then(() => {
            this.$notifySuccess('Variety updated!');
            this.close();
          })
          .catch(err => {
            this.$mapGraphQLError(err);
          })
          .catch(err => {
            console.error(err);
            this.$notifyFailure(
              'Unfortunately, we were unable to do that!',
            );
          });
      });
    },
    handleDelete() {
      this.$apollo
        .mutate({
          mutation: deleteVarietyMutation,
          variables: {
            input: {
              id: this.variety.id,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Variety disabled!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    handleRestore() {
      this.$apollo
        .mutate({
          mutation: restoreVarietyMutation,
          variables: {
            input: {
              id: this.variety.id,
            },
          },
          optimisticResponse: {
            __typename: 'Mutation',
            restoreVariety: {
              ...this.variety,
              deleted_at: null,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Variety restored!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
